import React from "react";
import PlanningTrip from "../components/PlanningTrip";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import banner from "../assets/images/KenyaTourism.jpg";
import Section from "../components/LandingSectionKenya";
import landingelephant from "../assets/images/LandingElephant.jpg";
import landingLion from "../assets/images/LandingRhino.jpg";
import Landingbaloon from "../assets/images/landingbaloon.jpg";
import LandingZebra from "../assets/images/LandingZebra.jpg";
import LandingPeople from "../assets/images/LandingPeople.jpg";
import LandingCheetah from "../assets/images/Landingcheetah.jpg";
import LandingWildlife from "../assets/images/LamdingWildlife.jpg";
import CruiseHeaderLanding from "../components/CruiseHeaderLanding";

const sections = [
  {
    id: "1",
    title:
      "Travel N' Relax is the Leading Luxury Travel Agent for Kenya Vacations",
    text: `Embark on a journey to unlock the magic of Kenya with a luxury vacation, meticulously designed by Travel N' Relax exclusively for you. Our unique experiences set us apart as the leading luxury travel agent for Kenya vacations.
From the rolling savannahs of the Masai Mara and the elephant-rich plains of Amboseli to the tropical beaches of Mombasa, our bespoke Kenya journeys offer a deeper connection with this magical destination that others only dream about. Whether it’s your first trip to Kenya or your fifth, we’ll craft a journey that is uniquely yours, blending heart-racing wildlife encounters with the soothing comfort of world-class lodges.
Picture yourself sipping a Dawa under acacia trees, waking to the sound of distant lions, spotting the Big Five from your safari land-cruiser, sunbathing under coconut palms blowing in a soft tropical breeze on a beautiful sun-kissed beach, or drifting over the savanna in a hot-air balloon at dawn—all made seamless by our expert Kenya vacation planners. What others only dream about will become your reality as you experience Kenya in ways only a local could!`,
    imageSrc: landingelephant,
    button: "Design My Dream Kenya Vacation",
  },
  {
    id: "2",
    title: "Discover Kenya! A Land of Contrasts",
    text: 'While Kenya is known the world over for its vast savannas filled with exotic wildlife and world-class safari experiences, a true journey through Kenya offers so much more. Imagine immersing yourself in an indigenous tribal village or sailing the pristine waters of the Indian Ocean on a traditional dhow boat while dolphins frolic beside you! Or visit wildlife conservation sanctuaries, where you can feed giraffes at a giraffe center or watch baby elephants play at an elephant orphanage. These sanctuaries are not traditional "zoos"—they are deeply committed to the care and conservation of these magnificent animals.\n\nWith Travel N Relax, your trip goes beyond the average itinerary. We take you past the veil of mass tourism to truly connect with Kenya in a way that will change you. Don’t just dream about a Kenya vacation—live it!',
    imageSrc: landingLion,
    button: "Design My Dream Kenya Vacation",
  },

  {
    id: "3",
    title: "Best Luxury Kenya Safari Vacation Experiences",
    text:
      "Let the wild welcome you—our Kenya safari experts craft journeys where indulgence andauthenticity blend seamlessly. Enjoy luxurious tented camps with en-suite bathrooms and private decks, where giraffes may pass by as you sip your morning coffee." +
      "\n\n" +
      "From Big Five game drives at Lake Nakuru or the Masai Mara to private rhino conservancies in Laikipia, every moment is designed to immerse you in nature without sacrificing comfort." +
      "\n\n" +
      "Reconnect with loved ones around a fire pit, explore untouched corners of Kenya on a hot air balloon, or relax with a wilderness spa treatment." +
      "\n\n" +
      "Whether it’s gourmet bush dinners, cultural encounters with the Maasai, or seeing elephants stroll in front of Mount Kilimanjaro, we’ll ensure your safari is filled with memories that last a lifetime.",
    imageSrc: Landingbaloon,
    button: "Speak with an Africa Safari Expert",
  },
  {
    id: "4",
    title:
      "Your Kenya vacation will be more than just a trip—it will be the story of a lifetime, crafted by the top Aurora Kenya Safari Travel Agent, Travel N&#39; Relax. From private park charters to personalized butler service, we handle every detail with luxury in mind.",
    text: "Whether you are planning a milestone celebration, honeymoon, or family adventure, Kenya delivers unforgettable moments at every turn. Our journeys also support conservation efforts and empower local communities, because how you travel matters.",
    imageSrc: LandingZebra,
    button: "Design My Dream Kenya Vacation",
  },
  {
    id: "5",
    title: "Hike the trails of Mount Kenya for breathtaking panoramic views.",
    text:
      "Connecting and unifying the world, one traveler at a time, has always been the mission of Travel N Relax." +
      "\n\n" +
      "In Kenya, we invite you to embark on an extraordinary journey as you meet an indigenous Maasai tribe where you will connect with the village chief, hear ancient tales brought to life by wise elders, and witness traditional dances and warrior rituals that echo through generations of heritage. Here, you will discover the art of crafting mud huts and handmade jewelry, guided by the skilled hands of the village mothers. Share a delicious, authentic Maasai meal with the villagers, and join in the laughter and games with the children. This exclusive, intimate experience promises to captivate your heart and soul at every turn, because with Travel N Relax, you don’t just travel, you become unified with the world, one traveler at a time." +
      "\n\n" +
      "For a deeper cultural engagement, we can also arrange a homestay in a suburban Nairobi home with a fully screened Kenyan host family. These English-speaking host families are vetted and background-checked to ensure you experience Kenya through genuine hospitality, delicious food, and shared life stories.",

    imageSrc: LandingPeople,
  },
  {
    id: "6",
    title:
      "Experience Kenya Like Never Before with the Best Kenya Safari Travel Agent in Colorado",
    text:
      "Celebrating 10, 25, or 50 years together? Relive your honeymoon dreams—now with giraffes at breakfast and starlit baths in the wild" +
      "\n\n" +
      "Newlyweds? Begin forever in one of the world’s most romantic destinations. First-time visitor or returning Kenya lover? Let its beauty stir your soul." +
      "\n\n" +
      "Our expert planners handle the details so you can focus on presence and connection. The majestic landscapes and peaceful rhythms of nature remind us of life’s most meaningful pleasures.",
    imageSrc: LandingCheetah,
  },
  {
    id: "7",
    title: "Go Wild in Luxury",
    text:
      "Let us handle the details. We’ll create a fully customized luxury Kenyan vacation you’ll never forget. A journey that will live in your heart and memory forever." +
      "\n\n" +
      "Experience Kenya. Be transformed. Let us create your vacation of a lifetime—Kenya is waiting. Awaken your dreams!",
    imageSrc: LandingWildlife,
    button: "Plan My Kenyan Safari",
  },
] as const;

const LandingKenyaVacations: React.FC = () => {
  return (
    <div>
      <CruiseHeaderLanding
        bannerImage={banner}
        bannerText="
 Big Moments Deserve Bigger Backdrops—Say “Yes” to Seamless Celebration"
      />
      {sections.map((section, idx) => (
        <Section key={section.id} {...section} invert={idx % 2 !== 0} />
      ))}
      <PlanningTrip
        headingplanning="Start Planning Your Family Adventure"
        paragraph="Let us take care of the details while you enjoy quality time with your family."
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default LandingKenyaVacations;
